import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['inputChange']

  set_value() {
    this.inputChangeTarget.value = this.inputChangeTarget.value == '' ? '1' : '';
  }
}
